var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.conversationSize && _vm.isFetchingList)?_c('div',{staticClass:"flex flex-1 items-center h-full bg-black-25 justify-center",class:{ dark: _vm.prefersDarkMode }},[_c('spinner',{attrs:{"size":""}})],1):_c('div',{staticClass:"flex flex-col h-full",class:{
    'is-mobile': _vm.isMobile,
    'is-widget-right': _vm.isRightAligned,
    'is-bubble-hidden': _vm.hideMessageBubble,
    'is-flat-design': _vm.isWidgetStyleFlat,
    dark: _vm.prefersDarkMode,
    'justify-end': !_vm.isEnabledWidgetV2,
  },attrs:{"data-mobile":_vm.isMobile}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }